var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconRadioButtonsList(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    enableBackground: "new 0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 82.2,
    y: 71.8,
    fill: "#898989",
    width: 173.9,
    height: 18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.2,
    y: 170.4,
    fill: "#898989",
    width: 173.9,
    height: 18
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#898989",
    d: "M31.7,108.4c17.5,0,31.8-14.2,31.8-31.8S49.2,44.9,31.7,44.9S-0.1,59.1-0.1,76.6S14.2,108.4,31.7,108.4z  M31.7,58.9c9.8,0,17.8,8,17.8,17.8s-8,17.8-17.8,17.8s-17.8-8-17.8-17.8S21.9,58.9,31.7,58.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#898989",
    d: "M31.7,147.6c-17.5,0-31.8,14.2-31.8,31.8s14.2,31.8,31.8,31.8s31.8-14.2,31.8-31.8S49.2,147.6,31.7,147.6z  M31.7,197.1c-9.8,0-17.8-8-17.8-17.8s8-17.8,17.8-17.8s17.8,8,17.8,17.8S41.5,197.1,31.7,197.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRadioButtonsList);
export default __webpack_public_path__ + "static/media/icon-radio-buttons-list.1637f0a3.svg";
export { ForwardRef as ReactComponent };